import Footer from '@/components/_rebrand/Footer';
import Header, { HeaderProps } from '@/components/_rebrand/Header';
import FOOTER_PROPS from '@/constants/global-props/footer';
import HEADER_PROPS, { BLOG_HEADER_PROPS, BLOG_HEADER_PROPS_WITHOUT_PROMO_BANNER } from '@/constants/global-props/header';
import { shouldHidePromoBannerOnPagePath } from '@/constants/global-props/header.utils';
import { isOnBlogPage } from '@/helpers/isOnBlogPage';
import MasterTemplate from '@/templates/MasterTemplate';
import { usePathname } from 'next/navigation';
import { FC, PropsWithChildren } from 'react';


/**
 * Determines header props based on the current page path.
 * Adds a banner if we are on the blog detail page (e.g., /blog/something).
 * This was requested by the Graphite SEO team.
 *
 * @param pagePath - The current page path, or null if not available
 * @returns HeaderProps to be used for the Header component
 */
const getHeaderProps = (pagePath: string | null): HeaderProps => {

  if (isOnBlogPage(pagePath)) {

    return shouldHidePromoBannerOnPagePath(pagePath) ? BLOG_HEADER_PROPS_WITHOUT_PROMO_BANNER : BLOG_HEADER_PROPS;

  }


  return HEADER_PROPS;
}

const BlogTemplate: FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => {


  const pathname = usePathname();

  const headerProps = getHeaderProps(pathname);

  return (
    <MasterTemplate
      className={className}
      navigation={
        <Header {...headerProps} forceOpaque />
      }
      footer={
        <Footer {...FOOTER_PROPS} hideTopPattern />
      }
    >
      {children}
    </MasterTemplate>
  );
};

export default BlogTemplate;
